<template>
  <div v-if="instance">
    <k-btn  @click="add">Add override</k-btn>

    <template v-for="(override,idx) in val">
      <div class="elevation-2 mt-2 pt-2 pl-2 pr-2">

      <k-layout row>
<!--        <k-flex c4>
          <date-time-picker  label="Start time" first-day-of-week="1" time-format="HH:mm" v-model="override.start_time"></date-time-picker>
        </k-flex>
        <k-flex c4>
          <date-time-picker  label="End time" first-day-of-week="1" time-format="HH:mm" v-model="override.end_time"></date-time-picker>
        </k-flex>-->
        <k-flex c4>
          <k-text-field persistent-hint :hint="end_time_str(override)" style="min-width:100%;" type="number" label="Duration in hours" :min="1" :max="24" v-model="override.duration" @input="calculate_end_time(override)"></k-text-field>
        </k-flex>
      </k-layout>


      <k-layout row>
        <k-flex c4>
          <k-autocomplete :items="override_types" label="Type" v-model="override.type" item-text="label" item-value="value" @change="clear_params(override)">
          </k-autocomplete>
        </k-flex>
        <k-flex c4>
          <k-autocomplete :items="id_items(override)" label="Alternative" v-model="override.id" item-text="label" item-value="value" clearable></k-autocomplete>
        </k-flex>
        <k-flex c3>
          <k-autocomplete :items="override_subtypes(override)" label="Param" v-model="override.subtype" item-text="label" item-value="value" @change="subtype_change(override)">
          </k-autocomplete>
        </k-flex>
        <k-flex c1>
           <k-btn icon @click="remove(override,idx)" icon-name="delete"></k-btn>
        </k-flex>
      </k-layout>


      <k-layout row>
      <k-flex c12>

        <template v-if="override.subtype == 'active'">
          <k-autocomplete label="Active" v-model="override.params.active" :items="active_items" item-text="label" item-value="value"></k-autocomplete>
        </template>

        <template v-else-if="override.subtype == 'device'">
          <k-autocomplete label="Network device" v-model="override.params.device" :items="devices" item-text="label" item-value="value"></k-autocomplete>
        </template>
        
        <template v-else-if="override.subtype == 'protocol'">
          <k-autocomplete label="Protocol" v-model="override.params.protocol" :items="protocol_items" item-text="label" item-value="value"></k-autocomplete>
        </template>

        <template v-else-if="override.subtype == 'latency'">
          <k-autocomplete label="Latency" v-model="override.params.latency" :items="latency_items" item-text="label" item-value="value"></k-autocomplete>
        </template>
        
        <template v-else-if="override.subtype == 'connection_priority'">
          <template v-for="device in filtered_devices">
              <k-layout row>
                <k-flex c6 style="align-content: center;"> {{device.label}}</k-flex>
                <k-flex c6>
                  <k-autocomplete label="Priority" v-model="override.params.connection_priority[device.value]" :items="connection_priorities" item-text="label" item-value="value"></k-autocomplete>
                </k-flex>
              </k-layout>
          </template>
        </template>
        <template v-else>
          <k-autocomplete disabled></k-autocomplete>
        </template>

      </k-flex>
    </k-layout>
  </div>
  </template>

  </div>
</template>

<script>

// Listan siivous vanhoista createen, tää pitää vielä testata

import SettingsModel from '@/models/settings.js'
import ChannelModel from '@/models/channel.js'
import InstanceModel from '@/models/instance.js'
import datelib from '@/lib/date.js';
import Vue from 'vue';
import DateTimePicker from '../../DateTimePicker';

export default {
  props: {
    value: Array,
    channel: Object
  },
  data () {
    return {
      override_types: [
        {label: "Output/Headend", value: "config:output:headend"},
        {label: "Output/Srtla", value: "config:output:srtla"}
      ],
      active_items: [
        {label: "True", value: true},
        {label: "False", value: false}
      ],
      protocol_items: [
        {label: "TCP", value: "tcp"},
        {label: "SRTLA", value: "srtla"}
      ],
      connection_priorities: [
        {label: "Disabled", value: 0},
        {label: "1 (low)", value: 1},
        {label: "2", value: 2},
        {label: "3", value: 3},
        {label: "4", value: 4},
        {label: "5", value: 5},
        {label: "6", value: 6},
        {label: "7", value: 7},
        {label: "8", value: 8},
        {label: "9", value: 9},
        {label: "10 (high)", value: 10},
      ],
      latency_items: [
        {label: "100ms", value: 100000},
        {label: "200ms", value: 200000},
        {label: "300ms", value: 300000},
        {label: "400ms", value: 400000},
        {label: "500ms", value: 500000},
        {label: "1.0s", value: 1000000},
        {label: "1.5s", value: 1500000},
        {label: "2.0s", value: 2000000},
        {label: "2.5s", value: 2500000},
        {label: "3.0s", value: 3000000},
        {label: "3.5s", value: 3500000},
        {label: "4.0s", value: 4000000},
        {label: "4.5s", value: 4500000},
        {label: "5.0s", value: 5000000},
        {label: "5.5s", value: 5500000},
        {label: "6.0s", value: 6000000},
        {label: "6.5s", value: 6500000},
        {label: "7.0s", value: 7000000},
        {label: "7.5s", value: 7500000},
        {label: "8.0s", value: 8000000},
        {label: "8.5s", value: 8500000},
        {label: "9.0s", value: 9000000},
        {label: "9.5s", value: 9500000},
        {label: "10.0s", value: 10000000}

      ],
      default_duration: 5,
      ws_channel: undefined,
      instance_status: undefined
    };
  },
  components: {
    DateTimePicker
  },
  created () {
    var cur_time = this.$store.state.timestamp;
    var new_val = _.filter(this.val, function(override) {
      return (override.end_time > cur_time);
    });
    this.val = new_val;
  },
  methods: {
    add () {
      if (typeof(this.val) == "undefined") this.val = [];
      var new_val = this.val;
      var start_time = this.$store.state.timestamp;
      new_val.push({start_time: start_time, duration: this.default_duration, end_time: (start_time + (this.default_duration * 3600)), params: {}});
      this.val = new_val;
    },
    calculate_end_time(override) {
      Vue.set(override, "end_time", override.start_time + (override.duration * 3600));
    },
    clear_params(override) {
      Vue.set(override, "params", {});
      Vue.set(override, "subtype", undefined);
      Vue.set(override, "id", undefined);
    },
    subtype_change(override) {
      Vue.set(override, "params", {});
//      this.clear_params(override);
      if (override.subtype == "active") {
        Vue.set(override.params, "active", true);
      }
      if (override.subtype == "protocol") {
        Vue.set(override.params, "protocol", "tcp");
      }
      if (override.subtype == "latency") {
        Vue.set(override.params, "latency", 1500000);
      }
      if (override.subtype == "connection_priority") {
        Vue.set(override.params, "connection_priority", {})
        this.filtered_devices.forEach(device => {
          Vue.set(override.params.connection_priority, device.value, 1);
        });
      }
    },
    override_subtypes(override) {
      if (override.type == "config:output:headend") {
        return [
        {label: "Active", value: "active"},
        {label: "Protocol", value: "protocol"},
        {label: "TCP Device", value: "device"},
        {label: "SRTLA Latency", value: "latency"},
        {label: "SRTLA Priority", value: "connection_priority"}
        ]
      }
      if (override.type == "config:output:srtla") {
        return [
        {label: "Active", value: "active"},
        {label: "Latency", value: "latency"},
        {label: "Priority", value: "connection_priority"}
        ]
      }
      return [];
    },
    remove (override, idx) {
      var new_val = this.val;
      new_val.splice(idx, 1);
      this.val = new_val;
    },
    end_time_str(override) {
      return datelib.format_date(override.end_time) +  " - " + datelib.format_time(override.end_time);
    },
    id_items (override) {
      if (override.type == "config:output:headend" || override.type == "config:output:srtla") {
        var type_filter = "headend";
        if (override.type == "config:output:srtla") {
          type_filter = "srtla";
        }

        var id_outs = _.filter(ChannelModel.outputs_list(this.channel), function(output) {
          return (typeof(output.id) != "undefined" && output.type == type_filter );
        });
        var ret = _.map(id_outs, function(output) {
          return {label: (output.title || output.alternative || output.id), value: output.id}
        });
        return [{label: 'All', value: 'all'}].concat(ret);
      } 
      return [];
    },
    get_ip(data, default_value) {
      if(_.isObject(data)) {
        return _.get(data, "ip", default_value);
      }
      return data || default_value;
    }
  },
  computed: {
    devices() {
      return _.map(_.get(this.ws_channel, "data.system.net"), (val, key) => {
        return {label: "" + key + " ("+this.get_ip(val, "none")+")", value: key};
      });
    },
    filtered_devices() {
      return _.filter(this.devices, (device) => {
        if (device.label.includes("lo")) return false;
        if (device.label.startsWith("tun")) return false;
        return true;
      });
    },
    instance() {
      var instance = ChannelModel.instance(this.channel);
      if (typeof(instance) != "undefined" && typeof(this.ws_channel) == "undefined") {
        this.ws_channel = this.$cloudserver.channel("instances:status:"+instance.id);
        this.ws_channel.join();
      }
      return instance;
    },
    val: {
      get() {
        return this.value || []
      },
      set(val) {
        this.$emit("input", val);
      }
    },
  }
}
</script>
